export default "__VITE_ASSET__CDNZ2bkg__"